import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBusiness = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16.0017 9.99919H18.5027M16.0017 13.0004H18.5027M16.0017 16.0017H18.5027M5.49731 9.99919H7.99835M5.49731 13.0004H7.99835M5.49731 16.0017H7.99835M10.4994 13.0004H13.5006M10.4994 16.0017H13.5006M10.4994 9.99919H13.5006M10.4994 6.99794H13.5006M12 19.0029V21.0038M7.99835 21.0038V3.99669C7.99835 3.44418 8.44625 2.99628 8.99877 2.99628H15.0013C15.5538 2.99628 16.0017 3.44418 16.0017 3.99669V21.0038M21.0038 21.0038V7.91132C21.0038 7.40688 20.5948 6.99794 20.0904 6.99794H16.0017M7.99835 6.99794H3.90965C3.4052 6.99794 2.99627 7.40688 2.99627 7.91132V21.0038M22.0042 21.0038H1.99585",
		stroke: "#111827",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgBusiness);
export default ForwardRef;
